import { Injectable } from '@angular/core';
import { UserAccountService } from '@/app/platform/platform-data/services/types';
import { AsyncResult } from '@common/result/asyncResult';
import { UserAccountEntity } from '@/app/platform/platform-data/models/user-account.entity';
import { ErrorInformation } from '@shared/models/error/error-information';
import { PlatformUserAccountService } from '@data/_generated-api/platform-api/services/platform-user-account.service';
import { err, ok } from '@common/result/Result';
import Morphism from 'morphism';

@Injectable({ providedIn: 'root' })
export class UserAccountFacade implements UserAccountService {
  constructor(private readonly apiService: PlatformUserAccountService) {}

  async getAll(...args: any[]): AsyncResult<UserAccountEntity[], ErrorInformation> {
    const result = await this.apiService.postUseraccountsQueryDatasource({ body: {} }).toPromise();
    if (!result.isValid) {
      return err();
    }

    const userAccounts = Morphism.map(UserAccountEntity, result.value.items);
    return ok(userAccounts);
  }
}
